<template>
  <div id="index">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <!-- bottombox end -->
    <div class="search_tab">
      <div class="search_Text w1200">和 "{{ keyword }}" 相关的内容</div>
      <div class="search_tab_c w1200">
        <router-link :to="{ path: '/search', query: { keyword: keyword } }"
          ><span :class="{ side: num == 0 }">全部</span>
        </router-link>
        <router-link
          :to="{ path: '/search_course', query: { keyword: keyword } }"
          ><span :class="{ side: num == 1 }">课程</span>
        </router-link>
        <router-link
          :to="{ path: '/search_TestPaper', query: { keyword: keyword } }"
          ><span :class="{ side: num == 2 }">练习-套卷</span>
        </router-link>
        <router-link
          :to="{ path: '/search_Section', query: { keyword: keyword } }"
          ><span :class="{ side: num == 3 }">练习-单项</span>
        </router-link>
        <!-- <router-link :to="{path:'/search_languageTest',query:{keyword:keyword}}"><span
            :class="{'side': num == 4}">全真模考</span></router-link> -->
      </div>
    </div>
    <div class="main w1200">
      <div
        class="search_null"
        v-if="
          courseArrNum == 0 &&
            KPTestsTestPaperNum == 0 &&
            KPTestsSectionNum == 0 &&
            MockNum == 0
        "
      >
        <img src="../../assets/courselist/search.png" alt="" class="wuImg" />
        <p>没有你要找的内容，可以换个关键词试试</p>
      </div>
      <div class="search_main class_main" v-if="courseArrNum != 0">
        <div class="search_con">相关的课程：</div>
        <ul class="clearfix">
          <li v-for="(item, index) in courseArr">
            <router-link
              :to="{ path: '/course_details', query: { Id: item.Id, nav: 8 } }"
            >
              <dl>
                <dt>
                  <img :src="item.CoverImg" /><i
                    :class="[item.Type == 2 ? 'courseBox' : '']"
                    >{{ item.Type == 2 ? "课程包" : "" }}</i
                  >
                </dt>
                <dd class="dd1">
                  <h2>{{ item.Title }}</h2>
                  <p class="p1" v-if="item.Field1">
                    <span>{{ item.Field1 }}</span>
                    <span>{{ item.Field3 }}</span>
                  </p>
                  <div class="p3">￥{{ item.Price }}</div>
                </dd>
                <!-- <dd class="dd2">
                  <p class="p2">
                    {{item.Label.replace(/,/g, "·")}}{{"·"+item.Field2+'课时'}}
                  </p>
                  <h2>{{item.Title}}</h2>
                  <p class="p2">
                    {{item.Field4}}
                  </p>
                  <p class="p1" v-if="item.Field1">
                    <span>{{ item.Field1 }}</span>
                    <span>{{ item.Field3 }}</span>
                  </p>
                  <p class="p4">
                    立即学习
                  </p>
                </dd> -->
              </dl>
            </router-link>
          </li>
        </ul>
      </div>
      <div
        class="search_main KPTestsTestPaper_main"
        v-if="KPTestsTestPaperNum != 0"
      >
        <div class="search_con">相关的练习-套卷：</div>
        <ul class="clearfix">
          <li v-for="(item, index) in KPTestsTestPaper">
            {{ item.Title }}
            <strong v-if="item.Unfinished">
              <span
                class="btn_status btn_status_1"
                @click="todetail(item, 'a_jump', 3)"
                >继续答题</span
              >
              <span
                class="btn_status btn_status_2"
                @click="todetail(item, 'a_jump', 1)"
                >重新答题</span
              >
            </strong>

            <span class="btn_status" v-else @click="todetail(item, 'a_jump', 2)"
              >去答题</span
            >
          </li>
        </ul>
      </div>
      <div
        class="search_main KPTestsSection_main"
        v-if="KPTestsSectionNum != 0"
      >
        <div class="search_con">相关的练习-单项：</div>
        <ul class="clearfix">
          <li
            v-for="(item, index) in KPTestsSection"
            class="other_item"
            :key="index"
          >
            <div class="answer_box">
              <div
                v-if="item.AnswerSectionId"
                class="score_div"
                @click.stop="todetail2(item, 99)"
              >
                上次结果
              </div>
              <div v-else>未作答</div>
            </div>
            <el-tooltip
              :content="'· ' + item.Title"
              placement="top"
              effect="light"
            >
              <div class="name_box of1">
                {{ "· " + item.Title }}
              </div>
            </el-tooltip>
            <div class="questions_count" v-if="!item.Unfinished">
              <div>题量：</div>
              <div class="gray">共{{ item.QuestionCount }}题</div>
            </div>
            <div
              v-if="
                item.Unfinished &&
                  item.QuestionCount - 0 > 1 &&
                  [8, 28].indexOf(item.SubjectType) == -1
              "
              class="df_view"
            >
              <div class="btn_status btn_status_1" @click="todetail2(item, 3)">
                继续答题
              </div>
              <div class="btn_status btn_status_2" @click="todetail2(item, 1)">
                重新答题
              </div>
            </div>
            <div class="btn_status_3" v-else @click="todetail2(item, 2)">
              <img src="../../assets/practiceSystem/icon01.png" />
            </div>
          </li>
        </ul>
      </div>
      <!-- <div class="search_main Mock_main" v-if="MockNum!=0">
        <div class="search_con">全真模考：</div>
        <ul class="clearfix">
          <li v-for="item,index in Mock"></li>
        </ul>
      </div> -->
    </div>

    <cdkey-modal ref="CDKModal">
      <template #modalMIddle>
        <div class="cdk_modal_main">
          <img
            src="@/assets/practiceSystem/modal_close.png"
            class="modal_close_icon"
            alt=""
            @click="modalClose"
          />
          <img
            src="@/assets/practiceSystem/cdk_modal_img.png"
            class="modal_img"
            alt=""
          />
          <div class="tips_modal">请联系您的留学/考培顾问，获取试卷兑换码</div>
          <div class="btn_modal" @click="modalClose">确定</div>
        </div>
      </template>
    </cdkey-modal>
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部
import cdkeyModal from "@/components/modal/cdkeyModal";

import { getRandom } from "@/common/utils";
import { setEncryption } from "@/api/common";
export default {
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    cdkeyModal
  },
  metaInfo() {
    return {
      title: "启德考培在线",
      meta: [
        {
          name: "keywords",
          content: "启德考培在线,启德考培在线课程,雅思在线课程,托福在线课程"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      tokenkey: "",
      pageTypeId: 13, //首页banner图
      num: 0,
      listBox: [], //列表盒子
      limit: 4,
      currentPage: 1,
      courseType: 0,
      keyword: "",
      courseArr: [],
      courseArrNum: 0,
      KPTestsTestPaper: [],
      KPTestsTestPaperNum: 0,
      KPTestsSection: [],
      KPTestsSectionNum: 0,
      Mock: [],
      MockNum: 0
    };
  },
  async created() {
    //自动触发写入的函数
    let that = this;
    that.keyword = that.$route.query.keyword;
    this.tokenkey = this.$cookies.get("token");
  },
  mounted() {},
  watch: {
    keyword(val, oldVal) {
      //普通的watch监听
      // console.log(val, oldVal)
      let that = this;
      that.setSearch();
    }
  },
  methods: {
    modalClose() {
      this.$refs.CDKModal.close();
    },
    setSearch() {
      let that = this;
      that.getSearch(that.currentPage, 48, that.limit, that.keyword);
      // 练习-套卷：
      that.getKPTestsTestPaper(that.currentPage, that.limit, that.keyword);
      // 自学备考
      that.getKPTestsSection(that.currentPage, that.limit, that.keyword);
    },
    getSearch(currentPage, courseType, limit, keyword) {
      // console.log("keyword", currentPage, courseType, limit, keyword)
      let that = this;
      this.$api.get(
        "https://schoolapi.eiceducation.com.cn/api/Search?page=" +
          currentPage +
          "&limit=" +
          limit +
          "&ContentType=" +
          courseType +
          "&keyword=" +
          keyword,
        "",
        res => {
          // console.log(res, 'res')
          if (res.data.code == 200) {
            if (courseType == 48) {
              that.courseArrNum = res.data.count;
              that.courseArr = res.data.results;
            }
          }
        }
      );
    },
    getKPTestsTestPaper(currentPage, limit, keyword) {
      let that = this;
      this.$api.get(
        "https://schoolapi.eiceducation.com.cn/api/KPTestsTestPaper?page=" +
          currentPage +
          "&limit=" +
          limit +
          "&keyword=" +
          keyword,
        "",
        res => {
          console.log(res, "练习-套卷");
          if (res.data.code == 200) {
            that.KPTestsTestPaperNum = res.data.count;
            that.KPTestsTestPaper = res.data.results;
          }
        }
      );
    },
    getKPTestsSection(currentPage, limit, keyword) {
      let that = this;
      this.$api.get(
        "https://schoolapi.eiceducation.com.cn/api/KPTestsSection?page=" +
          currentPage +
          "&limit=" +
          limit +
          "&keyword=" +
          keyword,
        "",
        res => {
          console.log(res, "练习-专项");
          if (res.data.code == 200) {
            that.KPTestsSectionNum = res.data.count;
            that.KPTestsSection = res.data.results;
          }
        }
      );
    },
    judgeIsAnswer() {
      let flag = false;
      if (this.$store.state.userInfo.Type == 2) {
        flag = true;
      } else if (
        this.$store.state.userInfo.VipList &&
        this.$store.state.userInfo.VipList.some(item1 => item1.VipType == 1)
      ) {
        flag = true;
      }
      return flag;
    },
    async todetail(itemData, type, restart) {
      console.log("itemData", itemData);
      if (this.tokenkey) {
        if (!itemData.IsPublic && !this.judgeIsAnswer()) {
          this.$refs.CDKModal.open();
          return;
        }
        // TODO
        //改域名
        this.$utils.gatAllNavUrl({
          ...itemData,
          paperId: itemData.TestPaperId,
          restart,
          a_flag: restart == 99 ? 2 : 1,
          transcript:itemData.Transcript,
        });
      } else {
        // 判断登录弹窗
        return (this.$refs.header.$refs.login.logintc = true);
      }
    },

    async todetail2(itemData, restart) {
      if (this.tokenkey) {
        if (!itemData.IsPublic && !this.judgeIsAnswer()) {
          this.$refs.CDKModal.open();
          return;
        }
        this.$utils.gatAllNavUrl({
          ...itemData,
          paperId: itemData.Id,
          restart,
          a_flag: restart == 99 ? 2 : 1,
          a_type: 2,
          transcript:itemData.AnswerSectionId,
        });
        // let { CourseType, SubjectType } = this;
        // // TODO
        // //改域名
        // let baseUrl = this.$utils.getWindowNavUrl(1);
        // console.log(baseUrl, "baseUrl");
        // let url = "";
        // if (itemData.CourseType == 3) {
        //   if (String(itemData.SubjectType) && itemData.SubjectType == -1) {
        //     url = `${baseUrl}/progress?testPaperId=${itemData.Id}&is_clear_storge=1`;
        //   } else if (
        //     String(itemData.SubjectType) &&
        //     itemData.SubjectType != -1
        //   ) {
        //     switch (parseInt(itemData.SubjectType)) {
        //       case 28: //听力
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=28&is_clear_storge=1`;
        //         break;
        //       case 27: //阅读
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=27&is_clear_storge=1`;
        //         break;
        //       case 30: //写作
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=30&is_clear_storge=1`;
        //         break;
        //       case 29: //口语
        //         url = `${baseUrl}/progress?sectionId=${itemData.Id}&subject_type=29&is_clear_storge=1`;
        //         break;
        //     }
        //   }
        // } else if (itemData.CourseType == 4) {
        //   baseUrl = this.$utils.getWindowNavUrl(3);
        //   url = `${baseUrl}/progress?id=${itemData.Id}&type=${
        //     itemData.SubjectType == -1 ? "test" : "section"
        //   }`;
        // } else if (itemData.CourseType == 2) {
        //   baseUrl = this.$utils.getWindowNavUrl(2);
        //   url = `${baseUrl}/progress?sectionId=${itemData.Id}&pageMeta=${
        //     itemData.SubjectType == -1 ? 1 : itemData.SubjectType
        //   }`;
        // } else if (itemData.CourseType == 607) {
        //   baseUrl = this.$utils.getWindowNavUrl(4);
        //   url = `${baseUrl}?sectionId=${itemData.Id}&pageMeta=${
        //     itemData.SubjectType == -1 ? 1 : itemData.SubjectType
        //   }`;
        // }
        // let tempWindow = window.open("/loading", getRandom(999, 100));
        // let res = await setEncryption({
        //   token: this.$cookies.get("token")
        // });
        // console.log("url", url);
        // url = `${url}&restart=${restart}`;
        // if (res.data.code == 200) {
        //   tempWindow.location.href = `${url}&ep=${
        //     res.data.results
        //   }&timestamp=${getRandom(999, 100)}`;
        // } else {
        //   tempWindow.close();
        // }
      } else {
        // 判断登录弹窗
        return (this.$refs.header.$refs.login.logintc = true);
      }
    }
  }
};
</script>

<style scoped lang="less">
.search_tab {
  padding: 30px;
}

.search_tab .search_Text {
  height: 20px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 20px;
  text-align: left;
  margin-bottom: 50px;
}

.search_tab_c span {
  display: inline-block;
  font-weight: 400;
  font-size: 26px;
  color: #333333;
  line-height: 26px;
  margin-right: 50px;
  cursor: pointer;
  font-weight: 400;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.search_tab_c span:hover {
  font-weight: 500;
  color: #ff0659;
}

.search_tab_c span.side {
  font-weight: 500;
  color: #ff0659;
}

.search_null {
  width: 1180px;
  margin: 0 auto;
  text-align: center;
}

.search_null p {
  font-size: 12px;
  color: #333;
  line-height: 24px;
}

.main {
  padding-top: 20px;
  padding-bottom: 78px;
}

.search_con {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  margin-bottom: 30px;
}

.search_main {
  margin-bottom: 50px;
}

.class_main ul li {
  width: 285px;
  height: 295px;
  float: left;
  background: #fbfbfb;
  position: relative;
  margin-right: 20px;
  overflow: hidden;
}

.class_main ul li:nth-child(4n) {
  margin-right: 0;
}

.class_main li dt {
  width: 285px;
  height: 185px;
  overflow: hidden;
}

.class_main li dt img {
  width: 285px;
  height: 185px;
  display: block;
}

.class_main li .dd1 {
  width: 265px;
  padding: 10px 10px 0;
  text-align: left;
  background: url(../../assets/index/to1.png) 261px 10px no-repeat;
  background-size: 14px 14px;
}

.class_main li .dd1 h2 {
  height: 20px;
  font-size: 20px;
  color: #000000;
  line-height: 20px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px;
}

.class_main li .dd1 .p1 {
  width: 100%;
  height: 22px;
  margin-bottom: 10px;
  overflow: hidden;
}

.class_main li .dd1 .p1 span {
  display: inline-block;
  padding: 0 10px;
  height: 22px;
  background: rgba(135, 141, 255, 0.05);
  border-radius: 13px 13px 13px 13px;
  line-height: 22px;
  text-align: center;
  font-size: 12px;
  color: #878dff;
  margin-right: 10rpx;
}

.class_main li .dd1 .p3 {
  height: 26px;
  font-weight: 400;
  font-size: 26px;
  color: #ff0659;
  line-height: 26px;
  text-align: right;
}

.class_main li .dd2 {
  width: 265px;
  max-height: 200px;
  padding: 18px 10px 0;
  text-align: left;
  position: absolute;
  bottom: -300px;
  left: 0;
  background: #fbfbfb;
  transition: 0.5s ease all;
}

.class_main li:hover .dd2 {
  bottom: 0;
}

.class_main li .dd2 h2 {
  height: 20px;
  font-size: 20px;
  color: #000000;
  line-height: 20px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px;
}

.class_main li .dd2 .p2 {
  font-weight: 350;
  font-size: 12px;
  color: #666666;
  line-height: 18px;
  margin-bottom: 8px;
}

.class_main li .dd2 .p1 {
  width: 100%;
  margin-bottom: 10px;
}

.class_main li .dd2 .p1 span {
  display: inline-block;
  padding: 0 10px;
  height: 22px;
  background: rgba(135, 141, 255, 0.05);
  border-radius: 13px 13px 13px 13px;
  line-height: 22px;
  background: rgba(135, 141, 255, 0.05);
  text-align: center;
  font-size: 12px;
  color: #878dff;
  margin-right: 10px;
  margin-bottom: 4px;
}

.class_main li .dd2 .p4 {
  font-weight: 400;
  font-size: 12px;
  color: #337cff;
  line-height: 12px;
  text-align: right;
  padding-right: 24px;
  margin-bottom: 20px;
  background: url(../../assets/index/to2.png) right no-repeat;
  background-size: 14px 14px;
}

.KPTestsTestPaper_main ul {
  border-top: 1px #d8d8d8 solid;
}

.KPTestsTestPaper_main ul li {
  width: 1140px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 16px;
  border-bottom: 1px #d8d8d8 solid;
  padding: 0 30px;
  cursor: pointer;
}

.KPTestsTestPaper_main ul li strong {
  font-weight: normal;
}

.KPTestsTestPaper_main ul li strong span {
  margin-left: 20px;
}

.KPTestsSection_main ul {
  margin-bottom: 30px;
}

.other_item {
  display: block;
  margin-right: 20px;
  margin-bottom: 30px;
  background-color: #fff;
  width: 285px;
  height: 150px;
  background: url(../../assets/practiceSystem/bj.png) no-repeat;
  background-size: 285px 150px;
  box-sizing: border-box;
  float: left;
  position: relative;
}

.other_item:nth-child(4n) {
  margin-right: 0;
}

.other_item .answer_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 82px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}

.other_item .answer_box .score_div {
  color: #337cff;
  text-decoration: underline;
  cursor: pointer;
}

.other_item .name_box {
  position: absolute;
  top: 51px;
  left: 20px;
  width: 245px;
  height: 30px;
  background: #878dff;
  border-radius: 16px 16px 16px 16px;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  line-height: 30px;
  text-align: left;
  text-indent: 10px;
}

.other_item .questions_count {
  position: absolute;
  top: 116px;
  left: 20px;
  display: flex;
  color: #333333;
}

.gray {
  color: #999999;
}

.other_item .btn_status_3 {
  position: absolute;
  top: 98px;
  left: 223px;
  width: 42px;
  height: 42px;
  cursor: pointer;
}

.other_item .btn_status_3 img {
  display: block;
  width: 42px;
  height: 42px;
}

.other_item .df_view {
  position: absolute;
  top: 104px;
  left: 75px;
  display: flex;
}

.other_item .df_view .btn_status {
  width: 90px;
  height: 32px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 32px;
  text-indent: 27px;
  cursor: pointer;
}

.other_item .df_view .btn_status_1 {
  border-radius: 16px 16px 16px 16px;
  background: url(../../assets/practiceSystem/icon02.png) 3px #15ceb2 no-repeat;
  background-size: 24px 24px;
  margin-right: 10px;
}

.other_item .df_view .btn_status_2 {
  border-radius: 16px 16px 16px 16px;
  background: url(../../assets/practiceSystem/icon03.png) 3px #337cff no-repeat;
  background-size: 24px 24px;
}
.cdk_modal_main {
  width: 800px;
  position: relative;
  text-align: center;
  .modal_close_icon {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 37px;
    height: 37px;
    cursor: pointer;
  }
  .modal_img {
    width: 375px;
    height: 330px;
  }
  .tips_modal {
    font-size: 24px;
    color: #333333;
    margin: 20px 0 40px;
  }
  .btn_modal {
    cursor: pointer;
    width: 160px;
    height: 42px;
    line-height: 42px;
    background: #ff0659;
    border-radius: 21px 21px 21px 21px;
    font-size: 20px;
    color: #ffffff;
    text-align: center;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/page2/search/search.vue